import * as angular from "angular";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {WorkingSlotsAlerts} from "./working-slots-alerts.service";
import {WorkingSlotsRequests} from "./working-slots-requests.service";
import {WorkingSlotEntity} from "../models/working-slot.model";
import {ILogService, IPromise, IQService} from "angular";

export class WorkingSlotsService {

  /* @ngInject */
  constructor(private workingSlotsRequests: WorkingSlotsRequests,
              private bringozLoaderService: BringozLoaderService,
              private workingSlotsAlerts: WorkingSlotsAlerts,
              private $log: ILogService,
              private $q: IQService) {
  }

  get(agentIds: string[], from: number, to: number, limit?: number, ignoreLoader?: boolean) {
    const deferred = this.$q.defer();

    if (!ignoreLoader) {
      this.bringozLoaderService.on();
    }

    this.workingSlotsRequests.get(agentIds, from,  to,  limit)
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error)
      })
      .finally(() => {
        if (!ignoreLoader) {
          this.bringozLoaderService.off();
        }
      });

    return deferred.promise
  }

  create(workingSlots: WorkingSlotEntity[], zoneId: string, overrideIds?: string[], override?: boolean) {
    return new Promise((resolve, reject) => {
        this.bringozLoaderService.on();
        this.workingSlotsRequests.create(workingSlots, zoneId, overrideIds, override)
          .then((createdWorkingSlot) => {
            this.workingSlotsAlerts.createSuccess();
            resolve(createdWorkingSlot);
          })
          .catch((error) => {
            this.$log.error(error);
            this.workingSlotsAlerts.createError(error);
            reject(error)
          })
          .finally(() => {
            this.bringozLoaderService.off();
          });
      }
    )
  }

  updateOne(workingSlot: WorkingSlotEntity, zoneId: string, overrideIds?: string[], override?: boolean) {
    return new Promise((resolve, reject) => {
        this.bringozLoaderService.on();
        this.workingSlotsRequests.updateOne(workingSlot, workingSlot.id,zoneId, overrideIds, override)
          .then((updatedWorkingSlot) => {
            this.workingSlotsAlerts.updateOneSuccess();
            resolve(updatedWorkingSlot);
          })
          .catch((error) => {
            this.$log.error(error);
            this.workingSlotsAlerts.updateOneError(error);
            reject(error)
          })
          .finally(() => {
            this.bringozLoaderService.off();
          });
      }
    )
  }

  deleteOne(workingSlotId) {
    return new Promise((resolve, reject) => {
        this.bringozLoaderService.on();
        this.workingSlotsRequests.deleteOne(workingSlotId)
          .then((result) => {
            this.workingSlotsAlerts.deleteOneSuccess();
            resolve(result);
          })
          .catch((error) => {
            this.$log.error(error);
            this.workingSlotsAlerts.deleteOneError(error);
            reject(error)
          })
          .finally(() => {
            this.bringozLoaderService.off();
          });
      }
    )
  }

  validateWorkingSlots(workingSlots: WorkingSlotEntity[], zoneId: string): IPromise<WorkingSlotEntity[]> {
    return new Promise((resolve, reject) => {
        this.bringozLoaderService.on();
        this.workingSlotsRequests.validateWorkingSlots(workingSlots, zoneId)
          .then((workingSlotsCollisions: WorkingSlotEntity[]) => {
            resolve(workingSlotsCollisions);
          })
          .catch((error) => {
            this.$log.error(error);
            this.workingSlotsAlerts.validateWorkingSlotsError(error);
            reject(error)
          })
          .finally(() => {
            this.bringozLoaderService.off();
          });
      }
    )
  }

}

angular
  .module('bringoz.admin.working-slots')
  .service('workingSlotsService', WorkingSlotsService);
